module.exports = __webpack_public_path__ + "static/nessuna_allerta-f6d76b3335a48ef9b6dc2d87952d4856.png";